// extracted by mini-css-extract-plugin
export var box = "Notice-module--box--c00f9";
export var box_md = "Notice-module--box_md--57c07";
export var box_xmd = "Notice-module--box_xmd--e1b10";
export var box_flex = "Notice-module--box_flex--00014";
export var box_lg = "Notice-module--box_lg--1a226";
export var box_sm = "Notice-module--box_sm--cc2f3";
export var box_outer = "Notice-module--box_outer--4f61e";
export var box_whiteBg = "Notice-module--box_white-bg--5e05e";
export var box_noMarginBottom = "Notice-module--box_no-margin-bottom--ed6ac";
export var box_noPadding = "Notice-module--box_no-padding--8bc4f";
export var box_outerGray = "Notice-module--box_outer-gray--a6dff";
export var box_dark = "Notice-module--box_dark--5d894";
export var box_zIndex = "Notice-module--box_z-index--fafc2";
export var box_zIndex6 = "Notice-module--box_z-index-6--83e2a";
export var box_eventsWithLine = "Notice-module--box_events-with-line--7562f";
export var box_featuresAo = "Notice-module--box_features-ao--b9e86";
export var box_verticalPaddings = "Notice-module--box_vertical-paddings--499ec";
export var clearP = "Notice-module--clearP--5b0e3";
export var clearP_vc = "Notice-module--clearP_vc--65394";
export var notice = "Notice-module--notice--a6ac0";
export var fadeInAnimation = "Notice-module--fadeInAnimation--ebafe";
export var placeHolderShimmer = "Notice-module--placeHolderShimmer--c42bb";